<template>
  <ModalMessage
    name="printMethodModal"
    title="Select Print Method"
    description="Choose which print method to use."
    :showClose="true"
    size="small"
    :buttons="[
      {
        text: 'Legacy Method',
        classList: ['bg-gray-100 text-gray-600 border-gray-300'],
        click: () => selectMethod('old')
      },
      {
        text: 'New Method',
        classList: ['bg-atlas-blue text-white'],
        click: () => selectMethod('new')
      }
    ]"
  />
</template>
<script>
import ModalMessage from "./ModalMessage.vue";
import { resolvePrintMethod } from "@/helpers/printMethodHelper";
export default {
  name: "PrintMethodModal",
  components: { ModalMessage },
  methods: {
    selectMethod(method) {
      resolvePrintMethod(this, method);
    }
  }
};
</script>
